import Phaser from 'phaser';
import SpritePool from '../../common/SpritePool';
import WhippedSpraySprite from './WhippedSpraySprite';

export default class WhippedSprayDisplay extends Phaser.GameObjects.Container {
  /**
   * 
   * @param {Phaser.Scene} scene 
   */
  constructor(scene,viewPositions) {
    super(scene);

    this._spray = {};
    this._spray.vy = 320;
    this.viewPositions = viewPositions;
    this.sprayPool = new SpritePool(WhippedSpraySprite, 200, this.scene);

    /** @type {WhippedSpraySprite[]} */
    this.activeSpray = [];

    this.viewRect = {
      top: this.viewPositions.top,
      left: this.viewPositions.left,
      bottom: this.viewPositions.bottom,
      right: this.viewPositions.right,
      width: this.viewPositions.right - this.viewPositions.left,
      height: this.viewPositions.bottom - this.viewPositions.top
    };

    this.hitRects = [
      { x: 0,y: 180,width: 160,height: 42, gX: 0.5, gY: 0.25, scale: 1 },
      { x: 40,y: 80,width: 110,height: 80, gX: 0.6, gY: 0.25, scale: 1 },
      { x: 80,y: 60,width: 35,height: 110, gX: 0.15, gY: 0.3, scale: 1 },
      { x: 120,y: 0,width: 10,height: 150, gX: 0.15, gY: 0.3, scale: 0.5 }
    ];
    this.curHitSizes = [
      { x: 0,y: 180,width: 22,height: 2 },
      { x: 40,y: 80,width: 22,height: 2 },
      { x: 80,y: 60,width: 22,height: 2 },
      { x: 120,y: 0,width: 22,height: 2 }
    ];

    this.hitChecker = { x: 0,y: 0,width: 0,height: 0 };
    this.curDropSpot = { x: 200, y: 200 };

    this.stickContainer = this.scene.add.container();
    this.add(this.stickContainer);
  }

  setHitArea (dabRect) {
    this.curDropSpot.x = dabRect.x;
    this.curDropSpot.y = dabRect.y;
    this.curHitSizes = [
      { x: 0,y: 180,width: 100,height: 2, isFull: false },
      { x: 40,y: 80,width: 10,height: 2, isFull: false },
      { x: 80,y: 60,width: 10,height: 2, isFull: false },
      { x: 120,y: 0,width: 10,height: 2, isFull: false }
    ];
    for (let i = 0; i < this.curHitSizes.length; i++) {
      const h = this.curHitSizes[i];
      h.x = -h.width / 2;

      h.y = 180;
    }
  }

  startSquirt (currentWhipNum) {
    const len = this.activeSpray.length;
    for (let i = 0; i < len; i++) {
      this.activeSpray[i].isValid = false;
    }
    this.currentToppingId = currentWhipNum;
    this.hasPainted = true;
  }

  moveHitArea (x,y) {
    this.curDropSpot.x = x;
    this.curDropSpot.y = y;
    this.curHitSizes = [
      { x: 0,y: 180,width: 100,height: 2, isFull: false },
      { x: 40,y: 80,width: 10,height: 2, isFull: false },
      { x: 80,y: 60,width: 10,height: 2, isFull: false },
      { x: 120,y: 0,width: 10,height: 2, isFull: false }
    ];
    for (let i = 0; i < this.curHitSizes.length; i++) {
      const h = this.curHitSizes[i];
      h.x = -h.width / 2;

      h.y = 180;
    }
  }

  adjustHitAreaForMove (x,y) {
    this.curDropSpot.x = x;
    this.curDropSpot.y = y;
  }

  getWhipImage (topOffset) {
    if (!this.hasPainted) return null;

    const img = new Phaser.GameObjects.RenderTexture(this.scene, this.viewPositions.left,this.viewPositions.top + topOffset,this.viewPositions.width, this.viewPositions.height);
    img.draw(this.stickContainer, -this.viewPositions.left, -this.viewPositions.top);

    this.stickContainer.removeAll(true);
    this.hasPainted = false;

    return img;
  }

  checkHits (sprite) {
    const len = this.curHitSizes.length;
    let grew = -1;
    for (let i = 0; i < len; i++) {
      if (this.curHitSizes[i].isFull === true) continue;
      this.hitChecker.x = this.curHitSizes[i].x + this.curDropSpot.x;
      this.hitChecker.y = this.curHitSizes[i].y + this.curDropSpot.y;
      this.hitChecker.width = this.curHitSizes[i].width;
      this.hitChecker.height = this.curHitSizes[i].height;
      if (this.checkForHit(sprite.screenRect, this.hitChecker)) {
        grew = i;
        break;
      }
    }
    return grew;
  }

  checkForHit (rect1,rect2) {
    if (rect1.x >= rect2.x + rect2.width || rect1.x + rect1.width <= rect2.x || rect1.y >= rect2.y + rect2.height || rect1.y + rect1.height <= rect2.y) return false;
    return true;
  }

  /**
   * 
   * @param {WhippedSpraySprite} sprite 
   * @param {*} s 
   */
  stickChunk (sprite, s) {
    const c = sprite.clone();
    c.scale = s;
    const r = 360 / (sprite.y - this.curDropSpot.y + 14) / 180;
    c.angle = r;
    this.stickContainer.add(c);
  }

  returnSpray (i) {
    const s = this.activeSpray[i];
    this.remove(s);
    this.sprayPool.returnSprite(s);
    this.activeSpray.splice(i,1);
    s.setVisible(false);
  }

  growRect (value) {
    const r = this.curHitSizes[value];
    const og = this.hitRects[value];

    let fullCount = 0;
    if (r.width < og.width) {
      r.x -= og.gX * 0.5;
      r.width += og.gX;
    }
    else {
      fullCount++;
    }
    if (r.height < og.height) {
      r.y -= og.gY;
      r.height += og.gY;
    }
    else {
      fullCount++;
    }
    if (fullCount >= 2) {
      r.isFull = true;
    }
  }

  doSpray (x,y) {
    const count = 3;
    let s = null;
    let vx = 0;
    if (this.curHitSizes[2].isFull === true) {
      vx = Phaser.Math.Between(0, 60) - 30;
    }
    else if (this.curHitSizes[3].isFull === true) {
      vx = Phaser.Math.Between(0, 10) - 5;
    }
    else {
      vx = Phaser.Math.Between(0,120) - 60;
    }

    const vy = this._spray.vy;
    const startOffsetX = 0;
    for (let i = 0; i < count; i++) {
      /** @type {WhippedSpraySprite} */
      s = this.sprayPool.getSprite();
      if (s === null) {
        console.error('ran out of cream.');
        return;
      }
      s.setVisible(true);
      const lt = 3000;
      const sid = this.currentToppingId;
      s.reset(x + startOffsetX,y,vx,vy,lt, sid, this.viewRect.bottom);
      s.isValid = true;
      this.activeSpray.push(s);
      this.add(s);
    }
  }

  update (dt) {
    const len = this.activeSpray.length - 1;
    if (len < 0) {
      return null;
    }
    let alive = false;
    let item = null;

    for (let i = len; i >= 0; i--) {
      item = this.activeSpray[i];
      alive = item.tick(dt);
      if (alive) {
        item.update();
        const wasHit = this.checkHits(item);
        if (wasHit >= 0) {
          let scale = (item.y - this.curDropSpot.y + 14) / 120;
          scale = Math.max(scale, 0.3);

          if (this.curHitSizes[wasHit].isFull === false) this.stickChunk(item, scale);
          this.returnSpray(i);
          const hlen = this.curHitSizes.length;
          for (let h = 0; h < hlen; h++) {
            this.growRect(h);
          }
        }
      }
      else {
        this.returnSpray(i);
      }
    }
  }
}